import React from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import IntlMessages from '../util/IntlMessages';
import CircularProgress from '@material-ui/core/CircularProgress';
// import iconGoogle from "../assets/images/icons/icon-google-login.svg";
// import iconFacebook from "../assets/images/icons/icon-facebook-login.svg";
// import FacebookLogin from 'react-facebook-login';
// import GoogleLogin from 'react-google-login';

import {
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
  userSignIn,
} from '../actions/Auth';

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: ''
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.authUser !== null) {
      this.props.history.push('/app/dashboard');
    }
  }

  componentWillMount() {
    if (this.props.authUser !== null) {
      this.props.history.push('/app/dashboard');
    }
  }

  render() {
    const {
      email,
      password
    } = this.state;
    // const responseFacebook = (response) => {
    //   console.log(response);
    //   this.props.userFacebookSignIn(response)
    // }
    // const responseSuccessGoogle = (response) => {
    //   console.log(response);
    //   this.props.userGoogleSignIn(response)
    // }
    // const responseFailureGoogle = (response) => {
    //   console.log(response);
    //   if (response.error !== 'idpiframe_initialization_failed') {
    //     this.props.userGoogleSignIn(response)
    //   }
    // }
    const { showMessage, loader, alertMessage } = this.props;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-login-content">
            <div className="text-center mb-4">
              <Link className="logo-ms" to="/" title="StanceBeam">
                <img src={require("../assets/images/logo-black.png")} alt="stancebeam" title="stanceBeam" />
              </Link>
            </div>
            <div className="app-login-header mb-4">
              <h3 style={{ color: '#4D4F5C' }}><IntlMessages id="appModule.welcomeText" /></h3>
            </div>

            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={<IntlMessages id="appModule.email" />}
                    fullWidth
                    onChange={(event) => this.setState({ email: event.target.value })}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(event) => this.setState({ password: event.target.value })}
                    margin="normal"
                    className="mt-1 my-sm-3"
                  />

                  <div className="mt-5 my-sx-5 d-flex align-items-center justify-content-center">
                    <Button onClick={() => {
                      this.props.showAuthLoader();
                      this.props.userSignIn({ email, password });
                    }} variant="contained" style={{ width: "250px" }} className="jr-btn bg-black text-white">
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                  </div>
                </fieldset>
              </form>

              {/* <div className="text-center-line mt-5 mb-4">Continue with</div>
              <div className="row">
                <div className="col-sm-6 text-center">
                  <GoogleLogin
                    clientId="313348750424-slov7kepkavnakpq84o4ut1qbun1cs2b.apps.googleusercontent.com" //CLIENTID NOT CREATED YET
                    buttonText=""
                    className="google-button-style"
                    children={
                      <img src={iconGoogle} title="stanceBeam" alt="Google"
                        onClick={() => {
                          this.props.showAuthLoader()
                        }}></img>
                    }
                    onSuccess={responseSuccessGoogle}
                    onFailure={responseFailureGoogle}
                  />
                </div>
                <div className="col-sm-6 text-center">
                  <FacebookLogin
                    icon={
                      <img src={iconFacebook} title="stanceBeam" alt="Facebook"
                        onClick={() => {
                          this.props.showAuthLoader();
                        }} />
                    }
                    textButton=""
                    cssClass="facebook-button-style"
                    appId="698483573982043" //APP ID NOT CREATED YET
                    fields="name,email,picture"
                    callback={responseFacebook}
                  />
                </div>
              </div>
             */}
            </div>
          </div>

        </div>
        {
          loader &&
          <div className="loader-view">
            <CircularProgress />
          </div>
        }
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div >
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser }
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  userFacebookSignIn,
  userGoogleSignIn,
})(SignIn);
